/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Remaining_CreditInputs */

const vi_customer_remaining_credit = /** @type {(inputs: Customer_Remaining_CreditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Còn lại`)
};

/**

* @param {Customer_Remaining_CreditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_remaining_credit = /** @type {((inputs?: Customer_Remaining_CreditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Remaining_CreditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_remaining_credit(inputs)
});